export default __webpack_public_path__ + "static/media/new_patient.1415ede6.svg";